import React from 'react';
import Header from '../base/Header';

const SolicitorHeader = ({ onMenuToggle }) => {
  const menuItems = [
    { label: '文書検索', path: '/solicitor/insurance/system/search' },
    { label: '文書検索履歴', path: '/solicitor/search/history' },
    { label: '搭載文書検索', path: '/solicitor/document-catalog' },
    { label: 'アカウント編集', path: '/solicitor/account/edit' },
  ];
  return (
    <Header onMenuToggle={onMenuToggle} menuItems={menuItems}/>
  );
};

export default SolicitorHeader;